import { createFileRoute } from '@tanstack/react-router';
import { ProtectedPriceCalculator } from '@uturn/portal/modules/price-calculator/pages/authenticated';
import z from 'zod';

const CalculatorIdParams = z.object({
	uuid: z.string().optional(),
});

export const Route = createFileRoute('/_protected/calculator/{-$uuid}')({
	params: {
		parse: (rawParams) => CalculatorIdParams.parse(rawParams),
	},
	component: ProtectedPriceCalculator,
});
